export default __webpack_public_path__ + "static/media/crv.9e93069b.png";